import { createShouldForwardProp, props } from '@styled-system/should-forward-prop';
var otherProps = ['nativeWidth', 'nativeHeight', 'minRows', 'maxRows']; // extend the forwarded props by stuff that styled-system doesn't deal with

var shouldForwardSystemProp = createShouldForwardProp([].concat(props, ['textDecoration', 'pointerEvents', 'visibility', 'transform', 'cursor']));
export var shouldForwardProp = function shouldForwardProp(prop) {
  return otherProps.includes(prop) ? true : shouldForwardSystemProp(prop);
};